import React from 'react';
interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}
export function Logo({
  size = 'md',
  className = ''
}: LogoProps) {
  const sizeClasses = {
    sm: 'text-xl',
    md: 'text-2xl',
    lg: 'text-4xl'
  };
  return <div className={`font-serif font-bold tracking-tight ${sizeClasses[size]} ${className}`} data-id="element-30">
      <span className="text-white" data-id="element-31">Geniac</span>
      <span className="text-amber" data-id="element-32">.io</span>
    </div>;
}